import Services from './Services'
import Offer from './Offer'
import React from "react";
import Hero from "./Hero";
import NewsLetter from "./NewsLetter";
import Products from "./Products";
import Choose from './Chooes';

const HomeIndex = () => {
  return (
    <div className='flax-col gap-14'>
      <Hero />
      <Services/>
      <div>
      <Offer/>
      <Products />
      <Choose/>
      </div>
      <NewsLetter />
    </div>
  );
};

export default HomeIndex;
